/**
 * Capitalizes the first letter and lowercases the rest.
 * Useful for normalizing inconsistent casing like "OYSTER SAUCE".
 */
export function formatName(name: string): string {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}
